/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Typescript_Faq_A7Inputs */

const en_to_typescript_faq_a7 = /** @type {(inputs: To_Typescript_Faq_A7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prefer a schema when one exists. Generating from OpenAPI or JSON Schema captures optionality, enums, formats, and constraints that no sample can reveal. Use this tool when the API has no published schema and a sample response is all you have.`)
};

const ko_to_typescript_faq_a7 = /** @type {(inputs: To_Typescript_Faq_A7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스키마가 있다면 그쪽을 쓰세요. OpenAPI나 JSON Schema에서 생성하면 어떤 샘플도 드러낼 수 없는 선택성, 열거형, 포맷, 제약을 담아낼 수 있습니다. API가 스키마를 공개하지 않아 샘플 응답만 가진 상황에서 이 도구를 쓰세요.`)
};

const ja_to_typescript_faq_a7 = /** @type {(inputs: To_Typescript_Faq_A7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スキーマがあるならそちらを使ってください。OpenAPI や JSON Schema から生成すれば、どんなサンプルでも明らかにできない任意性、列挙、フォーマット、制約を捉えられます。API がスキーマを公開しておらず、サンプルレスポンスしか手元にないときにこのツールを使ってください。`)
};

/**
* | output |
* | --- |
* | "Prefer a schema when one exists. Generating from OpenAPI or JSON Schema captures optionality, enums, formats, and constraints that no sample can reveal. Use ..." |
*
* @param {To_Typescript_Faq_A7Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_typescript_faq_a7 = /** @type {((inputs?: To_Typescript_Faq_A7Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Typescript_Faq_A7Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_typescript_faq_a7(inputs)
	if (locale === "ko") return ko_to_typescript_faq_a7(inputs)
	return ja_to_typescript_faq_a7(inputs)
});